import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";

function TerminalClaimsTableData({ data, selectedIds, onToggle, onEdit, onDelete, rowsPerPage }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center", width: "5%" },
    { Header: "Created At", accessor: "createdAt", align: "left" },
    { Header: "Rec No.", accessor: "receiptNo", align: "left" },
    { Header: "Policy No", accessor: "policyNumber", align: "left" },
    { Header: "Plan", accessor: "plan", align: "left" },
    { Header: "Hospital", accessor: "hospitalName", align: "left" },
    { Header: "Scheme", accessor: "scheme", align: "left" },
    { Header: "Beneficiary", accessor: "beneficiaryName", align: "left" },
    { Header: "Total Amount", accessor: "totalAmount", align: "right" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case "APPROVED":
      case "SUCCESS":
        return "success";
      case "PENDING":
        return "info";
      case "Reversed":
        return "error";
      default:
        return "secondary";
    }
  };

  const rows = (data || []).map((item) => ({
    checkbox: (
      <Checkbox
        size="small"
        checked={selectedIds.includes(item.id)}
        onChange={() => onToggle(item.id)}
      />
    ),
    createdAt: (
      <MDTypography variant="caption">{item.createdAt?.replace("T", " ") || ""}</MDTypography>
    ),
    receiptNo: <MDTypography variant="caption">{item.receiptNo || "N/A"}</MDTypography>,
    policyNumber: (
      <MDTypography variant="caption" color="text">
        {item.policyNumber}
      </MDTypography>
    ),
    plan: (
      <MDTypography variant="caption" color="text">
        {item.plan}
      </MDTypography>
    ),
    hospitalName: (
      <MDTypography variant="caption" color="text">
        {item.hospitalName}
      </MDTypography>
    ),
    scheme: (
      <MDTypography variant="caption" color="text">
        {item.scheme}
      </MDTypography>
    ),
    beneficiaryName: (
      <MDTypography variant="caption" color="text">
        {item.beneficiaryName}
      </MDTypography>
    ),
    totalAmount: (
      <MDTypography variant="caption" color="text">
        {item.totalAmount?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </MDTypography>
    ),
    status: (
      <MDBadge badgeContent={item.status} size="md" color={getStatusColor(item.status)} container />
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(item)}>
          <Icon>edit</Icon>
        </IconButton>
        {/*
        <IconButton size="small" color="error" onClick={() => onDelete(item)}>
          <Icon>delete</Icon>
        </IconButton>
        */}
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      entriesPerPage={{ defaultValue: rowsPerPage, entries: [rowsPerPage, 50, 100, 1000] }}
      isSorted={false}
      showTotalEntries={false}
      noEndBorder
      size="small"
    />
  );
}

TerminalClaimsTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default TerminalClaimsTableData;
